import React from 'react'
import { Outlet } from 'react-router-dom'
import FilDarian from '../../../Component/FilDarian/FilDarian'
import {CATEGORIE_COURS_NAVIGATION} from '../../../Routes/NAVIGATION_PATH'
import {ALL_COURS_NAVIGATION} from '../../../Routes/NAVIGATION_PATH'



function Cours() {
	const filD ={
		nom1 :'All courses',
		nom2 : 'Category courses',
		route1 : '',
		route2 : CATEGORIE_COURS_NAVIGATION
	  }
  return (
	<div className='pe-3 container'>
		<FilDarian 
      nom1={filD.nom1}
      nom2={filD.nom2}
      route1={filD.route1}
      route2={filD.route2}
      />
	<Outlet />
	</div>
  )
}

export default Cours
